/* eslint-disable prettier/prettier */
import styled, { css } from 'styled-components'

interface PerformanceProps {
  hours: number
  completed: boolean
}

interface HoursProps {
  hours: number
}

export const Container = styled.div`
  font-family: arial;
  width: 100%;
  border: 1px solid #ccc;
  padding: 3rem;

  @media only screen and (max-width: 400px) {
    padding: 1rem;
  }
`

export const Slide = styled.div`
  width: 100%;
  height: 123px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  gap: 12px;

  border: 1px solid #cfcfcf;

  p {
    margin: 0;
  }

  .value {
    color: #222222;
    font-size: 2rem;
    font-weight: 500;
    line-height: 2.3rem;
  }

  .label {
    color: #222222;
    font-size: 1.06rem;
    font-weight: 500;
    line-height: 1.25rem;
  }
`

export const BarGraph = styled.div`
  width: 100%;
  height: 300px;
  position: relative;
`

export const ShadowArea = styled.div`
  position: absolute;
  width: 100%;
  bottom: 0;
  background: linear-gradient(180deg, rgba(75, 133, 255, 0.21) 0%, rgba(131, 112, 247, 0) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
`

export const Columns = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;

  @media only screen and (max-width: 400px) {
    width: 110%;
    margin-left: -2rem;
  }
`

export const ScaleY = styled.div`
  width: 80px;
  height: 240px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
`

export const HoursY = styled.div<HoursProps>`
  width: 10px;
  height: 1px;
  background-color: black;
  position: relative;

  .label {
    position: absolute;
    text-align: center;
    font-style: normal;
    font-size: 15px;
    top: 50%;
    left: 50%;
    transform: translate(calc(-100% - 12px), -50%);
  }
`

export const ChartArea = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  position: relative;

  .chartLines {
    position: absolute;
    width: 100%;
    height: 80%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-end;

    .line {
      border: 1px solid #cccccc;
      width: 100%;
    }
  }
`

export const AreaBars = styled.div`
  border: 1px solid #ccc;
  display: flex;
  height: 240px;

  position: relative;
`

export const Floating = styled.div<{ horizontalOffset: number }>`
  position: absolute;
  top: -10px;
  left: 50%;

  ${({ horizontalOffset }) =>
    css`
      transform: translate(calc(-50% + ${horizontalOffset}px), -100%);
    `}

  color: #f9f9f9;
  font-size: 0.75rem;
  font-weight: 500;
  background: #2c2c2c;
  border-radius: 4px;
  padding: 12px 13px;
  opacity: 0;
  pointer-events: none;

  transition: opacity 0.3s ease;
  z-index: 20;
  width: max-content;

  @media only screen and (max-width: 400px) {
    position: absolute;
    left: -30px;
  }
`

export const FloatingArrow = styled.div<{ horizontalOffset: number }>`
  position: absolute;
  top: 60px;
  left: 93%;

  ${({ horizontalOffset }) =>
    css`
      transform: translate(calc(-50% + ${horizontalOffset}px), -100%);
    `}

  color: #f9f9f9;
  font-size: 0.75rem;
  font-weight: 500;
  background: #2c2c2c;
  border-radius: 4px;
  padding: 12px 13px;
  opacity: 0;
  pointer-events: none;

  transition: opacity 0.3s ease;
  z-index: 20;
  width: max-content;

  ::after {
    content: '';
    border-style: solid;
    border-width: 6px;
    border-color: transparent transparent #2c2c2c;
    position: absolute;
    top: 35%;
    left: 77%;
    margin-top: -25px;
  }

  @media only screen and (max-width: 400px) {
    position: absolute;
    left: 60%;

    ::after {
      left: 90%;
    }
  }
`

export const StudyGoalLine = styled.div`
  position: absolute;
  display: flex;
  justify-content: end;
  align-items: center;
  width: 100%;
  height: 2px;
  cursor: pointer;
  border: 1px solid #4b85ff;
  bottom: 0;
  z-index: 10;

  ${FloatingArrow} {
    opacity: 1;
    pointer-events: all;
  }

  .arrow {
    margin-right: -1.5rem;
  }

  .label {
    position: absolute;
    font-family: 'Montserrat';
    display: flex;
    justify-content: center;
    align-items: center;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    color: black;
    width: 78px;
    border-radius: 5px;
    height: 25px;
    border: 1px solid #4b85ff;
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
  }

  img {
    position: absolute;
    left: 100%;
  }
`

export const ScaleX = styled.div`
  height: 60px;
  display: flex;
`

export const Days = styled.div`
  width: calc(100% / 7);
  text-align: center;
  font-style: normal;
  font-size: 12px;

  hr {
    transform: rotate(90deg);
    width: 10%;
    font-weight: bolder;
    border-top: 1.5px solid #000000;
  }

  .mobile {
    display: none;
  }

  .desk::first-letter {
    text-transform: uppercase;
  }

  @media only screen and (max-width: 400px) {
    hr {
      width: 30%;
    }

    .dataStudy {
      display: none;
    }

    .mobile {
      display: block;
    }

    .mobile::first-letter {
      text-transform: uppercase;
    }

    .desk {
      display: none;
    }
  }
`

export const BarsY = styled.div`
  width: calc(100% / 7);
  display: flex;
  align-items: flex-end;
  justify-content: center;

  &:hover,
  &:focus {
    ${Floating} {
      opacity: 1;
      pointer-events: all;
    }
  }
`

export const Performance = styled.div<PerformanceProps>`
  position: relative;

  width: 25%;
  border: 1px solid #ccc;
  border-radius: 2px 2px 0 0;

  height: ${({ hours }) => `${(hours / 24) * 100}%`};
  max-height: 239px;
  background-color: ${({ completed }) => (completed ? '#77E0A1' : '#FD7878')};

  &:hover {
    background-color: ${({ completed }) => (completed ? '#4BAF73' : '#D25353')};
    cursor: pointer;
  }
`
